import apiClient from '../apiClient';

const condicionesServices = {
  obtenerCondiciones: async () => {
    try {
      const response = await apiClient.get(`/condiciones`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  obtenerCondicionPorId: async (id) => {
    try {
      const response = await apiClient.get(`/condiciones/${id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  actualizarCondicion: async (id, params) => {
    try {
      const response = await apiClient.put(`/condiciones/${id}`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  crearCondicion: async (params) => {
    try {
      const response = await apiClient.post(`/condiciones/`, params);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarCondicion: async (id) => {
    try {
      const response = await apiClient.delete(`/condiciones/${id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default condicionesServices;
